module.exports = {
  "zones": {
    "Australia/Adelaide": ["z", {
      "wallclock": 31536000000,
      "format": "AC%sT",
      "abbrev": "ACST",
      "offset": 34200000,
      "posix": 31501800000,
      "save": 0,
      "rules": "AS"
    }, {
      "wallclock": -2230156800000,
      "format": "AC%sT",
      "abbrev": "ACST",
      "offset": 34200000,
      "posix": -2230189200000,
      "save": 0,
      "rules": "Aus"
    }, {
      "wallclock": -2364076800000,
      "format": "ACST",
      "abbrev": "ACST",
      "offset": 32400000,
      "posix": -2364110060000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 33260000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "AS": [{
      "from": 2008,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2008,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1987,
      "to": 2007,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 2007,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2006,
      "to": 2006,
      "month": 3,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1995,
      "to": 2005,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1994,
      "to": 1994,
      "month": 2,
      "day": [7, 20],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1993,
      "to": 1993,
      "month": 2,
      "day": [7, 7],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1992,
      "to": 1992,
      "month": 2,
      "day": [7, 22],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1991,
      "to": 1991,
      "month": 2,
      "day": [7, 3],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1990,
      "month": 2,
      "day": [0, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1986,
      "month": 9,
      "day": [7, 19],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1971,
      "to": 1985,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1973,
      "to": 1985,
      "month": 2,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1972,
      "to": 1972,
      "month": 1,
      "day": [7, 27],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Aus": [{
      "from": 1943,
      "to": 1944,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 3],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 0,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 8,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 0,
      "day": [7, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 2,
      "day": [7, 25],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};